import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { stringifyIfPresent } from 'src/lib/common';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendCustomerSuggestionFreestyleTool,
  BackendMutationUpdateCustomerSuggestionFreestyleToolArgs,
} from 'src/types/backend';

import { FRAGMENT_FREESTYLE_TOOL } from './schema';

const MUTATION = gql`
  mutation UpdateCustomerSuggestionFreestyleTool(
    $id: ID!
    $name: String
    $generationTool: GenerationToolEnum!
    $allInstructionsData: JSON
  ) {
    updateCustomerSuggestionFreestyleTool(
      id: $id
      name: $name
      generationTool: $generationTool
      allInstructionsData: $allInstructionsData
    ) {
      ...SuggestionFreestyleTool
    }
  }
  ${FRAGMENT_FREESTYLE_TOOL}
`;

type Variables = BackendMutationUpdateCustomerSuggestionFreestyleToolArgs;
type Result = BackendCustomerSuggestionFreestyleTool;

export const updateSuggestionFreestyleTool = async ({
  allInstructionsData,
  ...rest
}: Variables) => {
  const response = await executeGqlMutation({
    mutation: MUTATION,
    variables: {
      ...rest,
      allInstructionsData: stringifyIfPresent(allInstructionsData),
    },
  });

  const result = getSingleProp<Result>(response.data);
  if (result) {
    result.allInstructionsData = result.allInstructionsData
      ? JSON.parse(result.allInstructionsData as string)
      : null;
  }
  return result;
};
